export default __webpack_public_path__ + "static/media/layout_dark_v2_info_attitudes.5b8ba6b7.svg";